import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthModalService {

    showLogin = new BehaviorSubject<boolean>(false);

    openLogin() {
        this.showLogin.next(true);
    }

    closeLogin() {
        this.showLogin.next(false);
    }
}